// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PgU4kt75x2vj6U2fkJX1{font-family:rubik,helvetica,arial,sans-serif;font-size:14px;font-weight:400;padding-bottom:18px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"description": `PgU4kt75x2vj6U2fkJX1`
};
export default ___CSS_LOADER_EXPORT___;
